export default "__VITE_ASSET__C7r0_AhQ__"